var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"multiple-select-custom-subtoptions"},_vm._l((_vm.suboptions),function(suboption,index){return _c('div',{key:suboption.value,staticClass:"multiple-select-custom-subtoption",class:{ active: suboption.selected },on:{"click":function($event){return _vm.selected(index)}}},[_vm._v(" "+_vm._s(suboption.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }